<style scoped></style>
<template>
  <swiper-content isProduct :contentEnabled="contentEnabled">
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <div class="content clue">
            <h2>YOU'VE FOUND COIN NO.2</h2>
            <p>Great, you’ve found the second of three hidden 5G coins. You’re well on your way! Now, here’s your clue to the final 5G coin: </p>
            <h2>Only my Ultra Wide lens could capture me in this wide array.</h2>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "Coin2Page",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
